import React from 'react'
import PortfolioCard from './PortfolioCard'
import V2PortfolioCard from './V2PortfolioCard'

const Portfolio = () => {
    return (
        <section id="Portfolio">
            <div className="portfolio-wrapper">
                <h1 className="section-head">Portfolio</h1>
                <div className="portfolio-grid">
                    {/* <PortfolioCard /> */}
                    <V2PortfolioCard />
                </div>
            </div>
        </section>
    )
}

export default Portfolio